import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-top_white",
  "use": "rt-portal-top_white-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-top_white\">\r\n<path class=\"st0\" d=\"M499.3,8l-488,305C4.3,317.3,0,325,0,333.3V1024h1024V333.3c0-8.3-4.3-16-11.3-20.4L524.7,8\r\n\tC516.9,3.1,507.1,3.1,499.3,8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/top_white.svg
// module id = 1892
// module chunks = 137